import userTypeHandlers from '../contexts/User/helpers/userTypeHandlers';
import {
  ParticipantState,
  V1Participant,
} from '@wix/ambassador-challenge-service-web/types';
import { IUserType } from '../contexts/User/UserContext';

export const isParticipantPage = ({
  participant = {},
  userType,
}: {
  participant: V1Participant;
  userType: IUserType;
}) => {
  return participant?.id && userTypeHandlers.isJoinedAlready(userType);
};

export function getOrderId(participant: V1Participant): string {
  if (participant) {
    switch (participant.transitions[0].state) {
      case ParticipantState.PAYMENT_STARTED:
        return participant.orderIds[0];
      default:
      case ParticipantState.PAYMENT_REQUESTED:
        return '';
    }
  }
  return '';
}
